import React, { createContext, useContext } from "react";

export type Messages = Record<string, string>;

type TranslationContextType = {
    t: (key: string) => string;
};

const TranslationContext = createContext<TranslationContextType>({
    t: (key) => key,
});

export function TranslationProvider({
    messages,
    children,
}: {
    messages: Messages;
    children: React.ReactNode;
}) {
    const t = (key: string) => messages[key] || key;
    return (
        <TranslationContext.Provider value={{ t }}>
            {children}
        </TranslationContext.Provider>
    );
}

export function useTranslation() {
    return useContext(TranslationContext);
}
